import { EvaluationStatus, TransactionMetadataStatus } from "@/model/DataModel"

export const evaluationStatusTranslationKeys: Record<EvaluationStatus, string> = {
	[EvaluationStatus.Unset]: "filters.project-status-unspecified",
	[EvaluationStatus.Like]: "filters.project-status-liked",
	[EvaluationStatus.Dislike]: "filters.project-status-discarded",
}

export const transactionMetadataStatusTranslationKeys: Record<TransactionMetadataStatus, string> = {
	[TransactionMetadataStatus.Pending]: "filters.transaction-status-pending",
	[TransactionMetadataStatus.InProgress]: "filters.transaction-status-progress",
	[TransactionMetadataStatus.Deferred]: "filters.transaction-status-deferred",
	[TransactionMetadataStatus.Done]: "filters.transaction-status-done",
}
